<div id="accoding-handbook" *ngIf="showPopup()">
    {{ "accoding-handbooks.message-part-1" | translate }}
    <a routerLink="manuals">
        {{ "accoding-handbooks.click-here" | translate }}
    </a>
    {{ "accoding-handbooks.message-part-2" | translate }}
</div>
